import { Box, HStack, Icon, Stat, Text } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';
import { Surface, SurfaceProps } from './Surface';

interface MetricCardProps extends Omit<SurfaceProps, 'children'> {
  label: ReactNode;
  value: ReactNode;
  helperText?: ReactNode;
  icon?: ReactElement;
  accentColor?: string;
}

export function MetricCard({
  label,
  value,
  helperText,
  icon,
  accentColor = 'ui.text.accent',
  variant = 'metric',
  ...props
}: MetricCardProps) {
  const valueColor = icon ? 'ui.text.primary' : accentColor;

  return (
    <Surface variant={variant} {...props}>
      <HStack justify="space-between" align="flex-start" gap="3">
        <Stat.Root>
          <Stat.Label textStyle="metricLabel">
            {label}
          </Stat.Label>
          <Stat.ValueText mt="1" color={valueColor} fontSize="2xl" fontWeight="700">
            {value}
          </Stat.ValueText>
          {helperText ? (
            <Text mt="1" fontSize="xs" color="ui.text.tertiary">
              {helperText}
            </Text>
          ) : null}
        </Stat.Root>
        {icon ? (
          <Box layerStyle="iconTile" boxSize="9" flexShrink={0} color={accentColor}>
            <Icon boxSize="4.5">{icon}</Icon>
          </Box>
        ) : null}
      </HStack>
    </Surface>
  );
}
